import { Route } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import AdminAccount from "../pages/adminDash";
import AdminNotifi from "../features/notification/adminNotifi";
import AdminModirators from "../features/modirators/adminModirators";
import AdminSetting from "../features/admin/adminSetting";
import { SettingBooks } from "../features/admin/setting/settingBooks";
import { SettingServices } from "../features/admin/setting/settingServices";
import { SettingOffers } from "../features/admin/setting/settingOffers";
import { SettingAdvancedServices } from "../features/admin/setting/settingAdvancedServices";
import { SettingPayments } from "../features/admin/setting/settingPayments";
import { SettingUsers } from "../features/admin/setting/settingUsers";
import { SettingProfile } from "../features/admin/setting/settingProfile";
import { lazy } from "react";
import { OtherSettings } from "../features/admin/setting/settingOtherSettings";

// lazyload pages
const AdminLogIn = lazy(() => import("../features/admin/Login/adminLogIn"));

export function AdminRoutes() {
    return (
        <Route>
            {/* <Route path="/" element={<Navigate to="/admin" replace />} /> */}
            <Route element={<AdminLayout />}>
                <Route path="/" element={<AdminAccount />} />
                <Route path="adminNotifi" element={<AdminNotifi />} />
                <Route path="modirators" element={<AdminModirators />} />
                <Route path="setting" element={<AdminSetting />}>
                    <Route path="books" element={<SettingBooks />} />
                    <Route index element={<SettingBooks />} />
                    <Route path="services" element={<SettingServices />} />
                    <Route path="payments" element={<SettingPayments />} />
                    <Route path="offers" element={<SettingOffers />} />
                    <Route path="advancedServices" element={<SettingAdvancedServices />} />
                    <Route path="profile" element={<SettingProfile />} />
                    <Route path="users" element={<SettingUsers />} />
                    <Route path="OtherSettings" element={<OtherSettings />} />
                </Route>
            </Route>
            <Route path="adminLogin" element={<AdminLogIn />} />
        </Route>
    );
}